import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Page from "@/pages/Page";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Resources from "@/pages/Resources";
import AdminApp from "@/admin/AdminApp";

const STATIC = [
  ["/", "home"],
  ["/about", "about"],
  ["/vision-mission", "vision-mission"],
  ["/what-we-do", "what-we-do"],
  ["/objectives", "objectives"],
  ["/governance", "governance"],
  ["/committees", "committees"],
  ["/membership", "membership"],
  ["/stakeholder-engagement", "stakeholder-engagement"],
  ["/mandate", "mandate"],
  ["/privacy", "privacy"],
  ["/terms", "terms"],
  ["/cookie-policy", "cookie-policy"],
];

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route
          path="*"
          element={
            <Layout>
              <Routes>
                {STATIC.map(([path, slug]) => (
                  <Route key={slug} path={path} element={<Page slug={slug} />} />
                ))}
                <Route path="/resources" element={<Resources />} />
                <Route path="/news" element={<News />} />
                <Route path="/news/:slug" element={<NewsDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
